var React = require('react');

function Email (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M13.1429 16.086C12.8 16.3431 12.4 16.4573 12 16.4573C11.6 16.4573 11.2 16.3431 10.8571 16.086L0 7.88593V19.4289C0 20.0573 0.514286 20.5716 1.14286 20.5716H22.8571C23.4857 20.5716 24 20.0573 24 19.4289V7.88593L13.1429 16.086Z","fill":"currentColor","key":0}),React.createElement("path",{"d":"M12 14.0854L24 4.99966V4.57109C24 3.94251 23.4857 3.42822 22.8571 3.42822H1.14286C0.514286 3.42822 0 3.94251 0 4.57109V4.99966L12 14.0854Z","fill":"currentColor","key":1})]);
}

Email.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Email;

Email.default = Email;
